import { animate, AnimationMetadata, group, query, style, transition, trigger } from '@angular/animations';

export const slideAnimation = trigger('slide', [
  transition(':enter', [
    style({ width: 0 }),
    animate('{{durationEnter}}ms cubic-bezier(.4, .22, .31, 1.01)',
      style({ width: '{{startWidth}}px' })
    )
  ]),
  transition(':leave', [
    style({ width: '{{startWidth}}px' }),
    group([
      query('.search-overlay-results', [
        animate('50ms 250ms cubic-bezier(.4, .22, .31, 1.01)', style({opacity: 0}))
      ], {optional: true}),
      animate('{{durationLeave}}ms cubic-bezier(.4, .22, .31, 1.01)',
        style({ width: 0 })
      )
    ])
  ], {
    params: {
      startWidth: 0,
      durationEnter: 300,
      durationLeave: 300
    }
  })
]) as AnimationMetadata;


